import { IKnmForm } from '../../../KnmPackage/MainModule/interfaces/IKnmForm';

interface IMarkedField {
  appendShowMarkCondition?: (
    values: IKnmForm,
    fieldNameIndexes: number[],
    isEnablePaperlessPassportDocument: boolean,
  ) => boolean;
}

export const isFieldRequiredForNextStatusesInTypeCarriedOut = (
  fieldName: string | undefined,
  values: IKnmForm,
  isEnablePaperlessPassportDocument: boolean,
): boolean => {
  if (!fieldName) {
    return false;
  }

  const idRegex = /\[\d+]/gi;
  const fieldNameTemplate = fieldName?.replaceAll(idRegex, '[{id}]');

  if (!fieldNameTemplate || !fieldsRequiredForNextStatusesInTypeCarriedOutRecord[fieldNameTemplate]) {
    return false;
  }

  const indexes = [...fieldName.matchAll(/\[(\d*)]/g)].map(item => Number.parseInt(item[1], 10));
  const markedField = fieldsRequiredForNextStatusesInTypeCarriedOutRecord[fieldNameTemplate];

  return (
    !markedField.appendShowMarkCondition ||
    markedField.appendShowMarkCondition(values, indexes, isEnablePaperlessPassportDocument)
  );
};

const fieldsRequiredForNextStatusesInTypeCarriedOutRecord: Record<string, IMarkedField> = {
  inspectorsErknm: {},
  /* acts: {},
  'acts[{id}].typeAct': {
    appendShowMarkCondition: (_values, _fieldNameIndexes, isEnablePaperlessPassportDocument) =>
      isEnablePaperlessPassportDocument,
  },
  'acts[{id}].canceledReason': {
    appendShowMarkCondition: (_values, _fieldNameIndexes, isEnablePaperlessPassportDocument) =>
      isEnablePaperlessPassportDocument,
  },
  'acts[{id}].canceledReasonDescription': {
    appendShowMarkCondition: (_values, _fieldNameIndexes, isEnablePaperlessPassportDocument) =>
      isEnablePaperlessPassportDocument,
  },
  'acts[{id}].canceledReasonDescriptionReactQuillEditor': {
    appendShowMarkCondition: (_values, _fieldNameIndexes, isEnablePaperlessPassportDocument) =>
      isEnablePaperlessPassportDocument,
  },
  'acts[{id}].organization.organizationName': {
    appendShowMarkCondition: (_values, _fieldNameIndexes, isEnablePaperlessPassportDocument) =>
      isEnablePaperlessPassportDocument,
  },
  'acts[{id}].numberAct': {},
  'acts[{id}].creationActDateTime': {
    appendShowMarkCondition: (_values, _fieldNameIndexes, isEnablePaperlessPassportDocument) =>
      !isEnablePaperlessPassportDocument,
  },
  'acts[{id}].holdingDateTime': {},
  'acts[{id}].durationDays': {
    appendShowMarkCondition: (values, fieldNameIndexes) => !values.acts?.[fieldNameIndexes[0]]?.durationHours,
  },
  'acts[{id}].durationHours': {
    appendShowMarkCondition: (values, fieldNameIndexes) => !values.acts?.[fieldNameIndexes[0]]?.durationDays,
  },
  'acts[{id}].fioAndPositionSinger': {},
  'acts[{id}].knoInspectors': {},
  'acts[{id}].events': {},
  'acts[{id}].events[{id}].inspectors': {},
  'acts[{id}].isViolatedMandatoryRequirements': {},
  'acts[{id}].acquaintanceType': {}, */
};
